import { t } from 'i18next'


/**
 * Form constants
 */

const STUDENT = 'student'
const CONCERN_REASONS = 'concern_reasons'
const TASK_DEMANDS = 'task_demands'
const PROBLEM_DESCRIPTION = 'problem_description'
const EXPECTED_PERFORMANCE = 'expected_performance'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [CONCERN_REASONS]: {
      label: `${t('rti.likely-reasons-for-concern')}`,
      name: CONCERN_REASONS,
      required: false,
    },
    [TASK_DEMANDS]: {
      label: `${t('rti.environmental-conditions-or-task-demands')}`,
      name: TASK_DEMANDS,
      required: true,
    },
    [PROBLEM_DESCRIPTION]: {
      label: `${t('rti.problem-description')}`,
      name: PROBLEM_DESCRIPTION,
      required: true,
    },
    [EXPECTED_PERFORMANCE]: {
      label: `${t('rti.expected-level-of-performance')}`,
      name: EXPECTED_PERFORMANCE,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [CONCERN_REASONS]: [],
  [TASK_DEMANDS]: '',
  [PROBLEM_DESCRIPTION]: '',
  [EXPECTED_PERFORMANCE]: ''
}

export default formModel
